import React, { useState, useEffect } from "react";
import { SortableContainer as sortableContainer } from "react-sortable-hoc";
import { Link } from "react-router-dom";
import arrayMove from "array-move";

import PracticePeriod from "./PracticePeriod";
import { SimpleMultiSelectorPresentational } from "../Filters/SimpleMultiSelector";
import { CUSTOM_SCOPES, FILTER_KEYS } from "../../../config/constants";

import "./PeriodList.scss";
import { PeriodsListProps } from "./types";
import { Drill } from "config/commonTypes";
import { useSelector } from "react-redux";
import { selectPeriodTypesByTeam } from "store/hooks/periodTypes";
import { buildPeriodTypesFilter } from "helpers";

const SortableContainer = sortableContainer(
  ({ children }: { children: React.ReactChild }) => {
    return (
      <ul style={{ paddingInlineStart: "0", marginBottom: "0px" }}>
        {children}
      </ul>
    );
  }
);

const PeriodsList = ({
  league,
  periods = [],
  setPeriods,
  profileFlag,
  teamId,
}: PeriodsListProps) => {
  const [newPeriod, setNewPeriod] = useState("");
  const [periodTypes, setPeriodTypes] = useState<string[]>([]);
  const [showFilter, setShowFilter] = useState(-1);
  const periodTypesArray = useSelector(selectPeriodTypesByTeam(teamId));
  const periodTypesFilter = buildPeriodTypesFilter(periodTypesArray);

  /* Each time a league changes, clean the prev league period types */
  useEffect(() => {
    if (periodTypes.length) {
      const leaguePeriods = periodTypesFilter.types;
      const intersected = periodTypes.filter((period) =>
        leaguePeriods.includes(period)
      );
      setPeriodTypes(intersected);
    }

    /* When changing the League, reset the selected periods */
    if (periods.length) {
      setPeriods([]);
    }
  }, [league, teamId]);

  const close = () => setShowFilter(-1);
  const handleNewProfileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value !== " ") setNewPeriod(e.target.value);
  };

  const addPeriod = (newPeriod: string) => {
    setPeriods([
      ...periods,
      {
        drillType: newPeriod,
        ...(periodTypes.length ? { periodType: periodTypes.join(",") } : {}),
      } as Drill,
    ]);
    setPeriodTypes([]);
  };

  const removePeriod = (id: string) => {
    setPeriods(periods.filter((period, index) => index !== +id));
  };

  const editPeriod = (id: string, name: string, periodTypes: string) => {
    const newPeriods = JSON.parse(JSON.stringify(periods));
    newPeriods[id].drillType = name;
    delete newPeriods[id].periodType;
    if (periodTypes) {
      newPeriods[id].periodType = periodTypes;
    }
    setPeriods(newPeriods);
  };

  const onSortEnd = ({
    oldIndex,
    newIndex,
  }: {
    oldIndex: number;
    newIndex: number;
  }) => {
    let items = [...periods];
    items = arrayMove(items, oldIndex, newIndex);
    setPeriods(items);
  };

  return (
    <>
      <div className="m-profile-o">
        <div style={{ paddingBottom: "7px" }}>
          <span
            style={{
              height: "16px",
              width: "102px",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            Practice Periods
          </span>
          {!profileFlag && (
            <span
              style={{
                textAlign: "right",
                fontFamily: "Roboto Condensed",
                fontSize: "15px",
                lineHeight: "18px",
                float: "right",
                paddingTop: "3px",
              }}
            >
              No profile?
              <Link to="/profiles">
                <span style={{ color: "#00658B", float: "right" }}>
                  &nbsp;Create One
                </span>
              </Link>
            </span>
          )}
        </div>
        <div className="new-practice" style={teamId === '-1'? {opacity: '0.5', pointerEvents: 'none'}:{}}>
          <div className="material-textbox" id="first-name-input" >
            <input
              className="material-input"
              required={newPeriod === ""}
              value={newPeriod}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (newPeriod !== "") {
                    addPeriod(newPeriod);
                  }
                  setNewPeriod("");
                }
              }}
              onChange={(e) => handleNewProfileChange(e)}
            />
            <span className="material-label">Enter a name and click add</span>
          </div>
          {newPeriod !== "" && newPeriod !== " " && (
            <button
              className="btn-plus"
              onClick={() => {
                addPeriod(newPeriod);
                setNewPeriod("");
              }}
            >
              +
            </button>
          )}
          <SimpleMultiSelectorPresentational
            show={showFilter === 3}
            close={close}
            open={() => setShowFilter(3)}
            filterData={periodTypes.map((type) => ({
              value: type,
              name: type,
            }))}
            changeFilterData={(values) =>
              setPeriodTypes(values.map((val) => val.value))
            }
            type={{
              name: "Period Type",
              types: [
                ...periodTypesFilter.types.map((type) => ({
                  value: type,
                  name: type,
                })),
              ],
              title: "PERIOD TYPE ",
              filterKey: FILTER_KEYS.PERIOD_TYPE,
            }}
            forceScope={CUSTOM_SCOPES.PERIOD_TYPE_PERIODS_LIST}
          />
        </div>
      </div>
      <div className="periods-d">
        <SortableContainer
          onSortEnd={onSortEnd}
          useDragHandle
          lockAxis="y"
          lockToContainerEdges
        >
          <>
            {periods.length > 0 ? (
              periods.map((drill, index) => (
                <PracticePeriod
                  editPeriod={editPeriod}
                  removePeriod={removePeriod}
                  id={"" + index}
                  index={index}
                  league={league}
                  name={drill.drillType}
                  types={drill.periodType || ""}
                  key={`item-${index}`}
                  style={{ zIndex: 9999999, backgroundColor: "#EDF0F2" }}
                  teamId={teamId}
                />
              ))
            ) : (
              <label>
                <i>No Periods addeds</i>
              </label>
            )}
          </>
        </SortableContainer>
      </div>
    </>
  );
};

export default PeriodsList;
